module.exports = __webpack_public_path__ + "static/media/paiement.29a989fa.svg";